export const getCustomerProductList = (productList: any[], customerId: string) => {
	return productList.filter((product: any) => ['FFF','LUM',customerId].includes(product.source));
};
